var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-content"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.loadingContent)?_c('div',{staticClass:"w3-center"},[_c('spinner-loading')],1):_c('div',{staticClass:"content-response",domProps:{"innerHTML":_vm._s(_vm.contentResponse)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b33c788","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/index.vue
// module id = dw7A
// module chunks = 3